import { render } from "./FooterPage.vue?vue&type=template&id=49603a8c&scoped=true"
import script from "./FooterPage.vue?vue&type=script&lang=js"
export * from "./FooterPage.vue?vue&type=script&lang=js"

import "./FooterPage.vue?vue&type=style&index=0&id=49603a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49603a8c"]])

export default __exports__